"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f48 = void 0;
exports.f48 = {
    "001": [
        406,
        536,
        1316,
        2026,
        2119,
        2243,
        3110,
        3144,
        3162,
        3163,
        3227,
        3331,
        3724,
        4262,
        4294,
        4295,
        5136,
        5407,
        5637,
        6288,
        6449,
        6450,
        6451,
        6452,
        6562,
        6897,
        6898,
        7566,
        7567,
        7883,
        7969,
        8131,
        8794,
        8996,
        8999,
        9180
    ]
};
